<template>
  <div>
    <el-button v-if="!icon" type="danger" size="small"  @click="dialogFormVisible=true">添加{{TNAME}}文件</el-button>
    <el-button v-else type="primary" size="mini" :icon="icon"  @click="dialogFormVisible=true" circle></el-button>
    <input type="file" ref="xlsxbutton" :accept="acceptfiletype" @change="uploadfiles" style="display: none" />
    <el-dialog title="添加文件" :visible.sync="dialogFormVisible" :show-close="false" width="560px" append-to-body>
        <el-form label-width="100px">
            <el-form-item label="文件类型：" v-if="par.ZJS.length>1">
                <el-select v-model="zjclass" placeholder="">
                    <el-option v-for="(item,index) in par.ZJS" :key="index" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="温馨提示：" style="font-size:10px;color:red;">
                <div v-html="config.msg"></div>
                <!-- <div>图片格式：jpg, png, gif，文件大小：10MB以内 </div>
                <div>文本格式：pdf 文件大小：20MB以内 </div>
                <div>媒体格式：flv(推荐),mp3,mp4(H264) 文件大小：200MB以内 </div>
                <div>压缩格式：zip,rar 文件大小：200MB以内  </div> -->
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="changefile()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props: {
        icon:{
            type:String,
            default:''
        },
        par:{
            type:Object,
            default:{objname:'sys_files'}
        },
        TNAME:{
            type:String,
            default:''
        },
        okupload: {
            //上传成功
            type: Function,
            default: null,
        },
    },
    data(){
        return{
            dialogFormVisible:false,
            currentfile:null,
            currentfiledesc:'',
            zjclass:'',
            acceptfiletype:'.pdf,.png,.jpg,.gif,.mp4,.flv,.mp3,.zip',
            config:{
            "zip": {
                "size": 204857600,
                "desc": "压缩文件不能大于200MB"
            },
            "pdf": {
                "size": 20480576,
                "desc": "文本文件不能大于20MB"
            },
            "mp4": {
                "size": 204805760,
                "desc": "视频文件不能大于200MB"
            },
            "jpg": {
                "size": 10240576,
                "desc": "图片文件不能大于10MB"
            },
            "mp3": {
                "size": 102405760,
                "desc": "音频文件不能大于100MB"
            },
            "msg": "图片格式：jpg, png, gif，文件大小：10MB以内<br/>文本格式：pdf 文件大小：20MB以内 <br/>媒体格式：flv(推荐),mp3,mp4(H264) 文件大小：200MB以内<br/>压缩格式：zip,rar 文件大小：200MB以内"
            }
        }
    },
    mounted(){
        if(this.par.zjclass){
                this.zjclass = this.par.zjclass
                if(this.zjclass=='任务书'){
                    this.acceptfiletype = ".pdf"
                }
            }
        if(!this.par.SID)
            this.par.SID = this.CU.cu.sid;
        if(!this.par.SSID){
            this.par.SSID = this.CU.cu.uid;
        }
        if(this.par.ZJS.length == 1){
            this.zjclass = this.par.ZJS[0]
        }

        this.getconfig()
    },
    methods:{
        getconfig:function(){
            let that =this
            that.GetData('GetUploadFileConfig',{},function(res){
                that.config = res.data.data;
            })
        },
        getext: function (filename) {
            var index1 = filename.lastIndexOf(".");
            var index2 = filename.length;
            var postf = filename.substring(index1 + 1, index2).toLowerCase(); //后缀名
            //alert(postf);
            return postf;
        },
        changefile(){
            if(this.par.zjclass){
                this.zjclass = this.par.zjclass
                if(this.zjclass=='任务书'){
                    this.acceptfiletype = ".pdf"
                }
            }
            if(this.par.ZJS.length>1 && !this.zjclass)
                this.$alert("请选择文件类型！", {
                    title: "错误",type:'error'
                });
            else
            {
                console.log(this.par)
                if(this.par.objname == "zj_works"){
                    let that =this
                    that.GetData('ChkUploadSSID',{ssid:that.par.SSID,zjclass:that.zjclass},function(res){
                        console.log(res)
                        that.$refs.xlsxbutton.click();        
                    },function(err){
                        that.$alert(err, {
                            title: "错误",type:'error'
                        });
                    })
                }else{
                    this.$refs.xlsxbutton.click();
                }

            }                
        },
        uploadfiles(e) {
            this.currentfile = null;
            const that = this;
            var fts = ["jpg", "png", "gif", "pdf", "mp3", "mp4", "flv", "zip", "rar"];
            var files = e.target.files || e.dataTransfer.files;
            if (files.length > 1) {
                that.$alert("一次只能上传1个文件。", {
                title: "错误"
                });
                that.$refs.xlsxbutton.value = "";
                return;
            }
            var ext = that.getext(files[0].name);
            if (fts.indexOf(ext) < 0) {
                that.$alert("不支持当前的文件格式" + ext + "！", {
                title: "错误"
                });
                that.$refs.xlsxbutton.value = "";
                return;
            }
            let flag = true
            let msg = ""
            switch(ext){
                case "jpg":
                if (files[0].size > that.config.jpg.size) {
                    flag = false
                    msg = that.config.jpg.desc//"jpg文件不能大于10MB"
                }
                break;
                case "png":
                if (files[0].size > that.config.jpg.size){// 10240576) {
                    flag = false
                    msg = that.config.jpg.desc//"png文件不能大于10MB"
                }
                break;
                case "gif":
                if (files[0].size > that.config.jpg.size){// 10240576) {
                    flag = false
                    msg = that.config.jpg.desc//"gif文件不能大于10MB"
                }
                break;
                case "mp3":
                if (files[0].size > that.config.mp3.size){// 102405760) {
                    flag = false
                    msg = that.config.mp3.desc//"mp3文件不能大于100MB"
                }
                break;
                case "mp4":
                if (files[0].size > that.config.mp4.size){//204805760) {
                    flag = false
                    msg = that.config.mp4.desc//"mp4文件不能大于200MB"
                }
                break;
                case "flv":
                if (files[0].size > that.config.mp4.size){//204805760) {
                    flag = false
                    msg = that.config.mp4.desc//"flv文件不能大于200MB"
                }
                break;
                case "pdf":
                if (files[0].size > that.config.pdf.size){//20480576) {
                    flag = false
                    msg = that.config.pdf.desc//"pdf文件不能大于20MB"
                }
                break;
                case "docx":
                if (files[0].size > that.config.pdf.size){//6144576) {
                    flag = false
                    msg = that.config.pdf.desc//"docx文件不能大于6MB"
                }
                break;
                case "xlsx":
                if (files[0].size > that.config.pdf.size){//6144576) {
                    flag = false
                    msg = that.config.pdf.desc//"xlsx文件不能大于6MB"
                }
                break;
                case "zip":
                if (files[0].size > that.config.zip.size){//204857600) {
                    flag = false
                    msg = that.config.zip.desc//"zip文件不能大于200MB"
                }
                break;
                case "rar":
                if (files[0].size > that.config.zip.size){//204857600) {
                    flag = false
                    msg = that.config.zip.desc//"rar文件不能大于200MB"
                }
                break;
            }
            if (!flag) {
                that.$alert(msg, {
                title: "错误"
                });
                this.$refs.xlsxbutton.value = "";
                return;
            }
            this.currentfile = files[0];
            this.currentfiledesc = files[0].name;
            if(this.currentfiledesc.indexOf('-- ')>=0){
                that.$alert('文件名包含不可识别的特殊字符，请修改文件名后再上传', {
                title: "错误"
                });
                this.$refs.xlsxbutton.value = "";
                return;
            }
            this.$refs.xlsxbutton.value = "";
            this.$prompt("文件名称", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /'*/,
                inputPlaceholder: "请输入文件名称",
                inputValue: that.currentfiledesc,
                inputErrorMessage: "请输入文件名称",
                })
                .then(({
                value
                }) => {
                let pars = {}
                if(that.par.objname == 'sys_files'){
                    pars = {
                        objname: "sys_files",
                        TID: that.par.TID,
                        FILENAME: value,
                    }
                }else{
                    pars = {
                        objname: "zj_works",
                        ZJCLASS: that.zjclass,
                        SID:that.par.SID,
                        FILENAME: value,
                    }
                    if(that.par.SSID){
                        pars.SSID = that.par.SSID
                    }
                }
                that.dialogFormVisible = false
                const loading = that.$loading({
                    lock: true,
                    text: '正在上传，请稍候...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let GuidFilename = that.GUID();
                that.PostBigFile('uploadBigFile',pars,that.currentfile,0,GuidFilename,function(res){
                    // console.log(res)
                    if(res.data.completed){
                        that.$refs.xlsxbutton.value = "";
                        if(that.okupload)
                            that.okupload(res)
                        loading.close()
                    }
                    else{
                        loading.text ='正在上传，请稍候...'+ res.data.Percent+"%";
                    }
                })
                }).catch((err) => {
                    
                });
            },
    }
}
</script>

<style>

</style>